<template>
  <b-modal title="RESPOSTAS" v-model="show" hide-footer>
    <div v-if="result" class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h6 class="mb-0 worksansr">
          FORMULÁRIO:
          <strong>{{ result.form_name }}</strong>
        </h6>
        <p class="worksansr">DESCRIÇÃO: {{ result.form_description }}</p>

        <h6 v-if="result.residents.length == 0">NENHUMA RESPOSTA FOI SALVA</h6>
        <v-data-iterator
          v-if="result.residents.length > 0"
          must-sort
          sort-by="name"
          :sort-desc="false"
          :items="result.residents"
          :page.sync="page"
          :items-per-page="items_per_page"
          @page-count="page_count = $event"
          hide-default-footer
        >
          <template #header>
            <h6 class="upper-text worksansr">
              <strong>
                {{ result.residents.filter((item) => item.answered).length }}
              </strong>
              de <strong>{{ result.residents.length }}</strong> respondidos
            </h6>
          </template>

          <template v-slot:default="{ items }">
            <div class="p-1">
              <h6
                class="upper-text worksansr"
                v-for="item in items"
                :key="item.id"
              >
                <strong>{{ item.name.toUpperCase() }}: </strong>
                {{ item.answered ? "RESPONDIDO" : "NÃO RESPONDIDO" }}
              </h6>
            </div>
          </template>

          <template #footer v-if="result.residents.length > 5">
            <v-pagination
              v-model="page"
              :length="page_count"
              class="worksansr"
            />
          </template>
        </v-data-iterator>
      </div>
      <div class="col-xl-12 text-right">
        <v-btn class="btn-acess worksansr" @click="show = false"> OK </v-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "Result",

  props: {
    /**
     * @type {{
     *   form_name: string,
     *   form_description: string,
     *   residents: {
     *     id: number,
     *     name: string,
     *     answered: boolean
     *   },
     * }}
     */
    result: [Object, undefined],
  },

  watch: {
    result(value) {
      if (value) this.show = true;
    },
  },

  data() {
    return {
      show: false,
      data: false,
      page: 1,
      items_per_page: 5,
      page_count: 1,
    };
  },
};
</script>

<style>
</style>